import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal } from "react-bootstrap";
import useStateRef from 'react-usestateref';
import { Link,useNavigate } from "react-router-dom";
import Card from "../../../../../components/Card";
import swal from 'sweetalert';
//import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";
import Select from 'react-select';
import "../../../../App.css";


const TableData = () => {

 
 const [SaveButtonText, setSaveButtonText] = useState("Save");
 
 
  useEffect(() => {

    
    
	
	
   if(sessionStorage.getItem("MasHallMark_Action")=="Add")
   {
	    setSaveButtonText("Save");
      
     
    document.getElementById("txtId").value="{Auto}";
   
	//Clear();
   
   }
   else if(sessionStorage.getItem("MasHallMark_Action")=="Edit")
   {
	   setSaveButtonText("Update");
	   Display(sessionStorage.getItem("MasHallMark_EditId"));
   }
   else if(sessionStorage.getItem("MasHallMark_Action")=="Delete")
   {
	   setSaveButtonText("Delete");
	   Display(sessionStorage.getItem("MasHallMark_EditId"));
   }
	
   ControlSettings();

   innitialSetValue();
   

  }, []);
  
  function innitialSetValue() {


  getLookup();
  
  }

  const [isDisabled, setisDisabled]=useState(false);


  const [show1, setShow1] = useState(false);
  const [sho, setSho] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
 
   const [TMshow1, setTMShow1] = useState(false);
   const TMhandleClose1 = () => setTMShow1(false);
  



 
  async function Clear()
   {
        

		handleClose1();
		
   }

function val(value)
{
	value=parseFloat(value);
	if(isNaN(value)==true)
		value=0;
	else
		value=value;
	
	return value;
}



function Calc()
{
  
  

}

async function ControlSettings()
{

  document.getElementById("txtId").disabled ='true';
  
  
  if((sessionStorage.getItem("MasHallMark_Action")=="Edit") || (sessionStorage.getItem("MasHallMark_Action")=="Delete"))
   {
  

    

   }

 



}

async function Display(EditId){
	  try
    {
     
      let postData = {
        EditId: EditId
    }


  

    const results = await apiService.postCall("mashallmark/Display",postData);


   if (results != "-1") {
     
	 let HeadData=results.data.Head;
   

   getLookup();
   
      document.getElementById("txtId").value=HeadData[0][0].id;
      document.getElementById("txtDescription").value=HeadData[0][0].Description;
			document.getElementById("txtFromWt").value=HeadData[0][0].FromWt;
			document.getElementById("txtToWt").value=HeadData[0][0].ToWt;
			document.getElementById("txtAmount").value=HeadData[0][0].Amount;
      

   }

    
    }
    catch (error) {
      console.log(error);
    }

  }


async function Save(){
	  try
		{
	
		
			
			
	
		 
		let postData = {
			"Action" : sessionStorage.getItem("MasHallMark_Action"),
			"EditId" : sessionStorage.getItem("MasHallMark_EditId"),
      "eBranchCode" : sessionStorage.getItem("BranchCode"),
			"FinMinDate": sessionStorage.getItem("FinMinDate"),
			"FinMaxDate": sessionStorage.getItem("FinMaxDate"),
			"EntryUser":sessionStorage.getItem("EntryUser"),
			"Description": document.getElementById("txtDescription").value,
      "FromWt": document.getElementById("txtFromWt").value,
      "ToWt": document.getElementById("txtToWt").value,
			"Amount": document.getElementById("txtAmount").value,
		
		}
    

   const results = await apiService.postCall("mashallmark/Save",postData);


  

   if (results != "-1") {

if(results.errorCode=="8888")
{


  swal({

    title: "Alert",
    text: results.data,
    icon: "info",
    button: "Ok"
    
  }).then(function () {
    
  });

  return;

}  
  if(sessionStorage.getItem("MasHallMark_Action")=="Add")
   {
    swal({

      title: "Success",
      text: "Successfully Add Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }

  else if(sessionStorage.getItem("MasHallMark_Action")=="Edit")
   {
    swal({

      title: "Success",
      text: "Successfully Update Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }
	 
  else if(sessionStorage.getItem("MasHallMark_Action")=="Delete")
  {
   swal({

     title: "Success",
     text: "Successfully Delete Your Details!",
     icon: "success",
     button: "Ok"

   }).then(function () {
     BackToList();
   });
 
 }
	 
      }
    }
    catch (error) {
      console.log(error);
    }

  }









  async function getLookup(){
	 try {
		
		 
		 
		let postData = [];
		
    const results = await apiService.postCall("mashallmark/Lookup",postData);

	 if (results != "-1") {

   
			
     
      }

    } catch (error) {
      console.log(error);
    }
}

 
  const navigate = useNavigate();
  const BackToList = () => {
    navigate('../dashboard/table/plussing/mashallmark/list');
  };

  return (
    <>
    

      <Row>
        <Card>
          <Card.Header className="d-flex justify-content-between">
            <div className="header-title">
              <h4 className="card-title">HM Rate Master Screen</h4>
            </div>
          </Card.Header>
          <Card.Body>
            <div className='container'>
              <div className='container-fluid'>
                <div className='row'>
                  <div className='col-lg-6'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='container-fluid py-4 '>
                        <div className='row py-2'>
                          <div className='col-md-3'>
                            <Form.Label>Id</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" id="txtId" placeholder="" />
                          </div>
                         
                          <div className='col-md-9'>
                            <Form.Label>Description</Form.Label>
                            <Form.Control type="text"  id="txtDescription" placeholder="" />
                          </div>

                         
                          </div>
						  
						         
						  
<div className='row py-2'>
                          <div className='col-md-4'>
                            <Form.Label>From Weight</Form.Label>
                            <Form.Control type="text"  id="txtFromWt" placeholder="" />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>From To</Form.Label>
                            <Form.Control type="text" id="txtToWt" placeholder="" />
                          </div>
                          <div className='col-md-4'>
                            <Form.Label>Amount</Form.Label>
                            <Form.Control type="text" id="txtAmount" placeholder="" />
                          </div>
                        </div>
                       
                        
                        </div>
                       
                      
                        

                      </div>

                    </div>

                  </div>
                 
              </div>
             

                 
             
           
			  
			    
				
				<Modal show={TMshow1} onHide={TMhandleClose1} className=".modal-lg" >
                  <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					</Form.Group>
					 </Modal.Body>
                 </Modal>
				
	
          
              <div className='pt-2' style={{ direction: 'rtl' }} >
                <Form.Group className="form-group">
                  <Button type="button" variant='btn btn-primary' >
                    <i className="btn-inner">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
                      </svg>
                    </i>
                    <span>Print</span>
                  </Button>{' '}
                  <Button type="button" variant="btn btn-danger" onClick={BackToList}>cancel</Button> {' '}
                  <Button type="button" variant="btn btn-primary" onClick={Save}>{SaveButtonText}</Button>
                </Form.Group>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Row >
    </>
  );
};

export default TableData;
